import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

/// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import ListItemIcon from 'components/List/ListItemIcon'

const style = theme => ({
  listItem: {
    color: theme.palette.text.secondary,
    '& a': {
      color: theme.palette.text.secondary,
      decoration: 'none',
    },
    '& strong': {
      color: theme.palette.text.primary,
      fontWeight: 600,
    },
  },
})

const Link = ({ url, linkText }) => {
  if (url || linkText) {
    return (
      <>
        {' ('}
        <OutboundLink href={url} target="_blank" rel="noreferrer">
          {linkText || url}
        </OutboundLink>
        {')'}
      </>
    )
  }
  return <span />
}

const Text = ({ title, url, text }) => {
  return (
    <>
      <strong>{title}</strong>
      {(text || url) && ' : '}
      {text}
    </>
  )
}

const RichListItem = ({ classes, id, icon, description, ...rest }) => {
  return (
    <ListItem
      className={classes.listItem}
      color="textSecondary"
      disableGutters={true}
    >
      <ListItemIcon icon={icon} />
      <ListItemText
        classes={{ textDense: classes.listItem }}
        secondary={description}
      >
        <Text {...rest} />
        <Link {...rest} />
      </ListItemText>
    </ListItem>
  )
}

export default withStyles(style)(RichListItem)
